import ms from 'ms'

export const UPDATE_INTERVAL = ms('15s')
export const STALE_TIME = ms('60s')
